<template>
  <svg class="jimun" height="50" width="100%" xmlns:xlink="http://www.w3.org/1999/xlink">
    <text x="0" y="15">
      Hello, it's me
      I was wondering if after all these years you'd like to meet
      To go over everything
      They say that time's supposed to heal ya
      But I ain't done much healing
      Hello, can you hear me?
      I'm in California dreaming about who we used to be
      When we were younger and free
      I've forgotten how it felt before the world fell at our feet
      There's such a difference between us
      And a million miles
    </text>
    <text x="0" y="32" fill="red">이것은 한글입니다.</text>Sorry, your browser does not support inline SVG.
  </svg>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
.jimun {
}
</style>